import React, { useState } from 'react';
import { GradientText, Poppins, Spacer } from 'src/common';
import TabsMenu, { TabWrap } from 'src/components/TabsMenu';
import WorkspaceVariablesForm from 'src/components/formComposed/WorkspaceVariablesForm';
import CheckBox from 'src/components/form/CheckBox';
import styled from 'styled-components';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { FromCSV } from 'src/components/modals/VariablesWorkspaceModal/forms/FromCSV';
import { CsvImportPreview } from 'src/components/VariableCSVReader/types';

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .check {
    display: flex;
    align-items: center;
    grid-gap: 10px;
    cursor: pointer;
    user-select: none;
  }
`;

interface WorkspaceVariablesProps {}

export const WorkspaceVariables: React.FC<WorkspaceVariablesProps> = () => {
  const [hideEmptyVariables, setHideEmptyVariables] = useState(true);
  const [activeTab, setActiveTab] = useState<'variables' | 'from_csv'>('variables');
  const [pendingCsvImport, setPendingCsvImport] = useState<CsvImportPreview | null>(null);

  return (
    <TabWrap>
      <Div>
        <GradientText>Variables</GradientText>
        {activeTab === 'variables' && (
          <div
            className="check"
            onClick={() => setHideEmptyVariables(!hideEmptyVariables)}
            data-cy="hide-empty-variables"
          >
            <Poppins color="cflowerBlue" px={14} weight={500}>
              Hide empty variables
            </Poppins>
            <CheckBox small isChecked={hideEmptyVariables} />
          </div>
        )}
      </Div>
      <Spacer $px={32} />
      <TabsMenu
        tabs={[
          { label: 'Variables', value: 'variables', dataCy: 'variables' },
          { label: 'Import From CSV', value: 'from_csv', dataCy: 'from_csv' },
        ]}
        activeTab={activeTab}
        setActiveTab={(tab) => {
          setActiveTab(tab);
          setPendingCsvImport(null);
          mpEvent(MPEvents.ButtonClick, {
            button: tab === 'variables' ? 'Tab:Variables' : 'Tab:Import From CSV',
            tags: ['WORKSPACE', 'VARIABLES'],
          });
        }}
      />
      <Spacer $px={45} />
      {activeTab === 'variables' && (
        <WorkspaceVariablesForm
          onClose={() => {}}
          scope={{ type: 'workspace' }}
          hideEmptyVariables={hideEmptyVariables}
        />
      )}
      {activeTab === 'from_csv' && (
        <FromCSV
          scope={{ type: 'workspace' }}
          pendingImport={pendingCsvImport}
          onPendingImportChange={setPendingCsvImport}
          onClose={() => {}}
          isModal={false}
        />
      )}
    </TabWrap>
  );
};
